


















import ExtButton from '@/components/ext/Button.vue';
import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';
import AppSvgIcon from '@/uikit/components/AppSvgIcon/AppSvgIcon.vue';

export default {
  components: { AppSvgIcon, ExtButton },
  props: {
    cfg: {
      type: [
        Object as () => LayoutConfig['general']['specialSections']['navSidebar'],
        Array,
      ],
      required: true,
    },
    data: {
      type: Array as () => LayoutDataSet['navSidebar'],
    },
  },
  created() {
    this.$store.commit('setMenuStatus', false);
  },
  computed: {
    getClass() {
      if (this.$store.state.menuOpen) {
        return 'open';
      }
      return 'close';
    },
  },
  methods: {
    closeThis() {
      this.$store.commit('setMenuStatus', false);
    },
    clickElement(route: any) {
      if (route === '/directivities' || route === '/vacancies') {
        window.location.assign(route);
      } else {
        this.$router.push(route);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/navSidebar/NavSidebar.vue